import type { FC, HTMLAttributes, ReactNode } from 'react'

import { cn } from '@/lib/utils'

export const cardStyles = (interactive: boolean = false, className?: string): string => {
    return cn(
        'rounded-xl border border-border bg-card shadow-card',
        interactive && 'transition-[transform,box-shadow,border-color] duration-200 hover:-translate-y-0.5 hover:border-primary/35 hover:shadow-raised motion-reduce:hover:translate-y-0',
        className
    )
}

interface CardProps extends HTMLAttributes<HTMLDivElement> {
    interactive?: boolean
    children: ReactNode
}

export const Card: FC<CardProps> = ({
    interactive = false,
    className,
    children,
    ...props
}): ReactNode => {
    return (
        <div className={cardStyles(interactive, className)} {...props}>
            {children}
        </div>
    )
}
